import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { GlobalService } from "src/app/services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { AppUtil } from "src/app/utils/app.util";

@Component({
	selector: "app-enrollment-cancellation",
	templateUrl: "./enrollment-cancellation.component.html",
	styleUrls: ["./enrollment-cancellation.component.css"]
})
export class EnrollmentCancellationComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public megStoreService: MEGStoreService,
		public userStoreService: USERStoreService,
		public userDataService: USERDataService,
		private cd: ChangeDetectorRef
	) {}
	public errorMessage = null;
	public isloading: boolean = false;
	public cancellationToken: boolean = false;
	ngOnInit() {
		this.globalService.cancellationToken$().subscribe(val => {
			this.cancellationToken = val;

			this.cd.detectChanges();
		});
	}
	public keep() {
		this.cancellationCall("false");
	}
	public cancel() {
		this.userStoreService.setUserProfile(null);
		this.dmvStoreService.addToProfileState = undefined;
		this.globalService.isAnnouncementFlow = true;
		this.globalService.isAnnouncementVisible = false;
		this.cancellationCall("true");
	}
	public back() {
		this.router.navigate(["contact-info"], { skipLocationChange: true });
	}
	public cancellationCall(type: string) {
		this.isloading = true;
		this.errorMessage = "";
		this.userDataService
			.accountCancellationconfirmed(this.dmvStoreService.sessionGUID, type)
			.subscribe(response => {
				if (response && response.status) {
					this.globalService.setDirectURLCall(false);
					this.isloading = false;
					if (response.headers.get("outcomeCode") === "0") {
						this.cd.markForCheck();
						this.router.navigate(
							[
								"app-enrollment",
								{ data: JSON.stringify(response.body), type: type }
							],
							{ skipLocationChange: true }
						);
					} else {
						this.errorMessage = response.headers.get("outcomeText");
					}
				}
				this.cd.markForCheck();
			});
	}
}
